import cloudinary from 'cloudinary-core'
import dpr from 'base/lib/dpr'
import store from 'base/store'

const cl = new cloudinary.Cloudinary({ cloud_name: 'everlane', secure: true })

const MANUAL_UPLOAD_BUCKET = 'static/'
const AUTOMATIC_UPLOAD_BUCKET = 'i/'

export function cloudinaryImageUrl(filename = '', options = {}) {
  let cloudinaryOptions = options.original
    ? {}
    : {
        quality: options.quality || 'auto',
        dpr: options.dpr || dpr,
        fetch_format: options.format || 'auto',
        clientHints: true,
        width: 'auto',
        transformation: [{ crop: 'scale' }],
      }

  const isSvg = filename.split('.').pop() === 'svg'

  if (options.size) {
    cloudinaryOptions.width || (cloudinaryOptions.width = Math.round(options.size))
    cloudinaryOptions.height || (cloudinaryOptions.height = Math.round(options.size))
  }

  // `width` and `height` take an optional string, so we are checking
  // for the existence of a number before we round
  if (options.width) {
    cloudinaryOptions.width =
      typeof options.width === 'number' ? Math.round(options.width) : options.width
  }

  if (options.height) {
    cloudinaryOptions.height =
      typeof options.height === 'number' ? Math.round(options.height) : options.height
  }

  if (options.smartCrop) {
    cloudinaryOptions.gravity = options.gravity || 'face:center'
  }

  if (options.gravity) {
    cloudinaryOptions.gravity = options.gravity
  }

  if (options.blur) {
    cloudinaryOptions.effect = `blur:${options.blur * 100}`
  }

  if (options.size || options.width || options.height) {
    cloudinaryOptions.crop = 'fill'
  }

  if (options.backgroundColor) {
    cloudinaryOptions.background = `rgb:${options.backgroundColor}`
  }

  if (options.transformation) {
    cloudinaryOptions.transformation = options.transformation
  }

  if (
    !filename.startsWith(AUTOMATIC_UPLOAD_BUCKET) &&
    !filename.startsWith(MANUAL_UPLOAD_BUCKET) &&
    !filename.includes('res.cloudinary.com')
  ) {
    if (!store.getState().appConfig.isProduction) {
      console.warn(`No bucket specified for ${filename}, assuming "${MANUAL_UPLOAD_BUCKET}"`)
    }

    filename = MANUAL_UPLOAD_BUCKET + filename
  }

  cl.responsive()

  if (options.original || isSvg) {
    return cl.url(filename)
  } else {
    return cl.url(filename, cloudinaryOptions)
  }
}

export function cloudinaryVideoUrl(filename = '', options = {}) {
  const cloudinaryOptions = {
    quality: 'auto',
    crop: 'scale',
    ...options,
  }

  return cl.video_url(filename, cloudinaryOptions)
}
